import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";
import { getRouter } from "./router";
import { installStartupDiagnostics } from "./lib/startup-diagnostics";
import "./styles.css";

installStartupDiagnostics();
console.info("[GAMO_DIAG] spa-main before getRouter");
const router = getRouter();
console.info("[GAMO_DIAG] spa-main before React render");

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);

console.info("[GAMO_DIAG] spa-main after React render call");